import apiInstance from './axiosBase'

export default {

    async login(params) {
        const searchParams = new URLSearchParams();
        searchParams.append('userId', encodeURIComponent(params.userId));
        if (params.password) {
            searchParams.append('password', encodeURIComponent(params.password));
        }
        if (params.status) {
            searchParams.append('status', encodeURIComponent(params.status));
        }
        if (params.token) {
            searchParams.append('token', encodeURIComponent(params.token));
        }
        searchParams.append('autoLogin', encodeURIComponent(params.autoLogin));
        searchParams.append('forceLogin', encodeURIComponent(params.forceLogin));
        return await apiInstance.axiosStdbV2Base({
            method: 'post',
            url: '/api/loginApi',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: searchParams
        })
    },

    async downloadProblem(params) {
        try {
            return await this.callApi('/download_problem', params);
        } catch(e) {
            console.error(e)
            return undefined
        }
    },

    async downloadProblemZip(downloadUrl) {
        try {
            const stdbSearchBaseUrl = import.meta.env.VUE_APP_STDB_SEARCH_BASE_URL
            downloadUrl = downloadUrl.replace('https://', '')
            downloadUrl = stdbSearchBaseUrl + downloadUrl.substring(downloadUrl.indexOf('/'))
            console.log(downloadUrl)

            const result = await apiInstance.axiosStdbSearchBase({
                method: 'get',
                url: downloadUrl,
                responseType: 'blob',
                headers: {
                    Accept: 'application/zip,application/octet-stream',
                },
            })
            console.log(result)
            if (result.status != 200) {
                return undefined
            }
            const fileName = this.getFilenameFromUrl(downloadUrl)
            return new File([result.data], fileName, { type: 'application/zip' })
        } catch(e) {
            console.error(e)
            return undefined
        }
    },
    getFilenameFromUrl: (url) => {
        if (!url.includes('/')) {
            return url
        }
        return url.substring(url.lastIndexOf('/') + 1)
    },
    async callApi(url, params) {
        return apiInstance.axiosStdbSearchBase({
            method: 'post',
            url: url,
            data: params
        })
    },
}